import { notifications } from '@mantine/notifications';
import { playSupportChatIncomingSound } from './support-chat-sound';

const MAX_PREVIEW = 140;

function preview(text: string, imageCount = 0): string {
  const trimmed = text.trim();
  if (trimmed) {
    if (trimmed.length <= MAX_PREVIEW) return trimmed;
    return `${trimmed.slice(0, MAX_PREVIEW)}…`;
  }
  if (imageCount > 0) {
    return imageCount === 1 ? 'Фото' : `Фото (${imageCount})`;
  }
  return '';
}

const shownIncomingMessageIds = new Set<number>();

export function showSupportChatIncomingToast(params: {
  title: string;
  body: string;
  imageCount?: number;
  messageId?: number;
  onOpen?: () => void;
}) {
  if (params.messageId != null) {
    if (shownIncomingMessageIds.has(params.messageId)) return;
    shownIncomingMessageIds.add(params.messageId);
    window.setTimeout(() => shownIncomingMessageIds.delete(params.messageId!), 10_000);
  }
  playSupportChatIncomingSound();
  notifications.show({
    title: params.title,
    message: preview(params.body, params.imageCount ?? 0),
    color: 'blue',
    autoClose: 6000,
    onClick: (event) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest('button')) return;
      params.onOpen?.();
    },
  });
}

